import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalFiltersDef } from "./PersonalFiltersDef";


export class PersonalFilters extends Entity<PersonalFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalFiltersDef(), parentKeys);
        this.Form = import('./PersonalFiltersForm').then((module) => module.PersonalFiltersForm);
        this.Title = "Personal Filters";
    }
}